import {Link, useNavigate} from 'react-router-dom';
import {ReactNode} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useIsDarkMode} from '@ui/themes/use-is-dark-mode';
import authBgSvg from './auth-bg.svg';
import {useTrans} from '@ui/i18n/use-trans';
import {useSettings} from '@ui/settings/use-settings';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}

export function AuthLayout({heading, children, message}: AuthPageProps) {
  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();
  const navigate = useNavigate();
  const {trans} = useTrans();

  return (
    <main className="relative flex min-h-screen flex-col items-center overflow-y-auto bg-alt px-14 pt-70 md:px-[10vw]">
      {/* 🔁 Repeating pattern background */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${authBgSvg})`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',
          backgroundPosition: 'top left',
          filter: isDarkMode ? 'blur(1px)' : 'none',
          opacity: isDarkMode ? 0.2 : 1,
        }}
      />

      <img
        src={isDarkMode ? branding.logo_light : branding.logo_dark}
        className="z-10 m-auto mb-16 block h-70 w-auto cursor-pointer"
        alt="Logo"
        onClick={() => navigate('/')}
      />


      <div className="z-10 mx-auto w-full max-w-[440px] rounded-lg bg px-40 mb-30 pb-32 pt-40 shadow md:shadow-xl">
        {heading && <h1 className="mb-30 text-xl">{heading}</h1>}
        {children}
        {message && <div className="text-md z-10 mt-36 font-bold text-center">{message}</div>}
        <AuthLayoutFooter />
      </div>

      
  </main>
);
}